import { RootState } from '../types'

export const loadingSelector = (state: RootState) => state.isAppLoading
